import React, { useState, useRef, useEffect } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import './../Styles/CustomSelect.css';

const CustomSelect = ({
    value,
    onChange,
    onOpenChange,
    options = [],
    placeholder = 'Select',
    disabled = false,
    error = false,
    className = '',
    style = {}
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [dropUp, setDropUp] = useState(false);
    const dropdownRef = useRef(null);

    // Notify parent when open state changes
    useEffect(() => {
        if (onOpenChange) {
            onOpenChange(isOpen);
        }
    }, [isOpen, onOpenChange]);

    // Check available space below to decide drop-down vs drop-up
    useEffect(() => {
        if (isOpen && dropdownRef.current) {
            const rect = dropdownRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;
            if (spaceBelow < 200 && spaceAbove > spaceBelow) {
                setDropUp(true);
            } else {
                setDropUp(false);
            }
        }
    }, [isOpen]);

    // Close on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    // Find current selected option label
    const selectedOption = options.find(opt => {
        if (typeof opt === 'object' && opt !== null) {
            return String(opt.value) === String(value);
        }
        return String(opt) === String(value);
    });

    const displayLabel = selectedOption
        ? (typeof selectedOption === 'object' ? selectedOption.label : selectedOption)
        : (value !== undefined && value !== null && value !== '' ? String(value) : placeholder);

    const isPlaceholder = value === undefined || value === null || value === '';

    const handleSelect = (val) => {
        onChange(val);
        setIsOpen(false);
    };

    return (
        <div 
            className={`pms-custom-select-container ${isOpen ? 'open' : ''} ${dropUp ? 'drop-up' : ''} ${error ? 'has-error' : ''} ${disabled ? 'disabled' : ''} ${className}`}
            ref={dropdownRef}
            style={style}
        >
            <button
                type="button"
                className="pms-custom-select-trigger"
                onClick={() => !disabled && setIsOpen(prev => !prev)}
                disabled={disabled}
            >
                <span className={`pms-custom-select-label ${isPlaceholder ? 'is-placeholder' : ''}`}>
                    {displayLabel}
                </span>
                <FiChevronDown 
                    className="pms-custom-select-chevron" 
                    size={14} 
                />
            </button>

            {isOpen && (
                <div className="pms-custom-select-menu">
                    {options.map((opt, index) => {
                        const optValue = typeof opt === 'object' && opt !== null ? opt.value : opt;
                        const optLabel = typeof opt === 'object' && opt !== null ? opt.label : opt;
                        const isSelected = String(value) === String(optValue) && optValue !== '';

                        return (
                            <div
                                key={index}
                                className={`pms-custom-select-item ${isSelected ? 'selected' : ''}`}
                                onClick={() => handleSelect(optValue)}
                            >
                                <span>{optLabel}</span>
                                {isSelected && <span className="pms-custom-select-check">✓</span>}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;
